import { useQuery } from "@tanstack/react-query"
import { websiteProductService } from "@/api/websiteProductService"

export const useWebsiteProduct = (id: number) => {
  return useQuery({
    queryKey: ["website-product", id],
    queryFn: ({ signal }) => websiteProductService.getProduct(id, signal),
    enabled: !!id,
  })
}

